import React from 'react';


import Styles from './Styles.module.scss';
import TermsView from '../anonymous/legal/TermsView.jsx';

class TermsAndConditions extends React.Component {

    componentDidMount() {
    }

    render() {
        return (
            <div className={ Styles.rightContent }>
               <div className={ Styles.details }>
                    <TermsView />
               </div>
            </div>
        )
    }
}

export default TermsAndConditions;